<div
  #specificContainer
  class="iu-specific-window iu-specific-window-container"
  [attr.data-cy-specific-window-name]="name">
  @if (!isModal && isLoading) {
    <p-progressBar [mode]="'indeterminate'" [showValue]="false" [styleClass]="'loading-progressbar'" [value]="0" />
  }
  <p-scrollPanel [style]="{ width: '100%', height: 'calc(100% - 30px)' }">
    <div class="p-col-12">
      <div class="fields">
        <ng-template iuDynamicContainer />
      </div>
    </div>
    <div class="iu-specific-btn-container" [ngClass]="[shouldAddPadding ? 'shouldAddPadding' : '']">
      @if (!needUpdate) {
        <iu-button-ui
          btnType="info"
          class="p-col-12 p-md-3 p-lg-3"
          label="{{ 'specificWindow.openBanking.testConnection' | translate }}"
          (click)="$event.preventDefault(); $event.stopPropagation(); testConnection()" />
        <iu-button-ui
          btnType="primary"
          class="p-col-12 p-md-3 p-lg-3"
          label="{{ 'specificWindow.openBanking.syncTransactions' | translate }}"
          (click)="$event.preventDefault(); $event.stopPropagation(); syncTransactions()" />
      }
      @if (isModal) {
        <iu-button-ui
          btnType="success"
          class="p-col-12 p-md-3 p-lg-3"
          icon="fa fa-check"
          label="{{ 'specificWindow.openBanking.manageAccess' | translate }}"
          (click)="$event.preventDefault(); $event.stopPropagation(); manageAccess()" />
      }
    </div>
  </p-scrollPanel>
</div>
